/* Program Name: userLookUpColumns.js
 **  Description: a file containing a list of columns for the User XGrid
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS200241  2021-03-17  STT  Initial program
 *********************************************************************************/

//columns holds the columns that will be used for the UserMaint grid
export const columns = [
  { headerName: 'Display Name', field: 'dispName', width: 250 },
  { headerName: 'Email', field: 'email', width: 175 },
  { headerName: 'UserID', field: 'login', width: 175 },
]
